package er.prateek.crossly.persistence

import com.russhwolf.settings.Settings
import er.prateek.crossly.share.IncomingChallengePrefs
import kotlinx.serialization.json.Json

private val json = Json { ignoreUnknownKeys = true }
private const val KEY_INCOMING = "incoming_challenge"

class SettingsIncomingChallengeStore(
    private val settings: Settings,
) : IncomingChallengeStore {
    override fun load(): IncomingChallengePrefs {
        val raw = settings.getStringOrNull(KEY_INCOMING) ?: return IncomingChallengePrefs()
        return runCatching {
            json.decodeFromString(IncomingChallengePrefs.serializer(), raw)
        }.getOrDefault(IncomingChallengePrefs())
    }

    override fun save(prefs: IncomingChallengePrefs) {
        settings.putString(KEY_INCOMING, json.encodeToString(IncomingChallengePrefs.serializer(), prefs))
    }
}
